export const getFullName = ({ firstname, lastname }: { firstname: string; lastname: string }) =>
  `${firstname} ${lastname}`

export const formatMoney = (amount: number) => {
  const str = Number.isInteger(amount) ? amount : amount.toFixed(2).replace(".", ",")
  return str + " €"
}
